import { coded, failure } from "@/lib/errors";

/**
 * Calls the middle-tier server to get user data.
 * @param middletierToken The access token for the middle-tier.
 */
export async function callGetUserDataApi(middletierToken: string): Promise<any> {
  try {
    const response = await fetch(`/getuserdata`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${middletierToken}`,
        "Content-Type": "application/json",
      },
    }).catch(() => Promise.reject(coded({ id: "error-network" })));

    if (!response.ok) {
      throw await failure(response, "error-microsoft-account");
    }

    return await response.json();
  } catch (err: any) {
    console.error("API call failed:", err);
    // Re-throw the error to be handled by the calling function
    throw err;
  }
}
